'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseProps = exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = exports.propTypes = {
  display: _propTypes2.default.oneOf(['block', 'inline-block', 'inline', 'table', 'table-row', 'table-cell', 'flex', 'inline-flex'])
};

var parseProps = exports.parseProps = function parseProps(_ref) {
  var display = _ref.display,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ['display', 'style']);

  var styles = {};

  if (display) styles.display = display;

  return _extends({ style: _extends({}, styles, style) }, props);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvZGlzcGxheS5qcyJdLCJuYW1lcyI6WyJwcm9wVHlwZXMiLCJkaXNwbGF5Iiwib25lT2YiLCJwYXJzZVByb3BzIiwic3R5bGUiLCJwcm9wcyIsInN0eWxlcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7O0FBRU8sSUFBTUEsZ0NBQVk7QUFDdkJDLFdBQVMsb0JBQVVDLEtBQVYsQ0FBZ0IsQ0FDdkIsT0FEdUIsRUFFdkIsY0FGdUIsRUFHdkIsUUFIdUIsRUFJdkIsT0FKdUIsRUFLdkIsV0FMdUIsRUFNdkIsWUFOdUIsRUFPdkIsTUFQdUIsRUFRdkIsYUFSdUIsQ0FBaEI7QUFEYyxDQUFsQjs7QUFhQSxJQUFNQyxrQ0FBYSxTQUFiQSxVQUFhLE9BSXBCO0FBQUEsTUFISkYsT0FHSSxRQUhKQSxPQUdJO0FBQUEsTUFGSkcsS0FFSSxRQUZKQSxLQUVJO0FBQUEsTUFEREMsS0FDQzs7QUFDSixNQUFNQyxTQUFTLEVBQWY7O0FBRUEsTUFBSUwsT0FBSixFQUFhSyxPQUFPTCxPQUFQLEdBQWlCQSxPQUFqQjs7QUFFYixvQkFBU0csb0JBQVlFLE1BQVosRUFBdUJGLEtBQXZCLENBQVQsSUFBNENDLEtBQTVDO0FBQ0QsQ0FWTSIsImZpbGUiOiJkaXNwbGF5LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuXG5leHBvcnQgY29uc3QgcHJvcFR5cGVzID0ge1xuICBkaXNwbGF5OiBQcm9wVHlwZXMub25lT2YoW1xuICAgICdibG9jaycsXG4gICAgJ2lubGluZS1ibG9jaycsXG4gICAgJ2lubGluZScsXG4gICAgJ3RhYmxlJyxcbiAgICAndGFibGUtcm93JyxcbiAgICAndGFibGUtY2VsbCcsXG4gICAgJ2ZsZXgnLFxuICAgICdpbmxpbmUtZmxleCdcbiAgXSlcbn1cblxuZXhwb3J0IGNvbnN0IHBhcnNlUHJvcHMgPSAoe1xuICBkaXNwbGF5LFxuICBzdHlsZSxcbiAgLi4ucHJvcHNcbn0pID0+IHtcbiAgY29uc3Qgc3R5bGVzID0ge31cblxuICBpZiAoZGlzcGxheSkgc3R5bGVzLmRpc3BsYXkgPSBkaXNwbGF5XG5cbiAgcmV0dXJuIHsgc3R5bGU6IHsgLi4uc3R5bGVzLCAuLi5zdHlsZSB9LCAuLi5wcm9wcyB9XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/enhancers/display.js
// module id = 1145
// module chunks = 0